import { Card, Text, View } from "@src/components";

interface WasteSenseHeroProps {
  /** Tenant display name, e.g. "Merri-bek City Council". */
  tenantName: string;
  /** Pre-formatted reporting window line (e.g. "25 May ... AEST (7 days)"). */
  reportingWindow: string;
}

/**
 * Top-of-report header block: small label, big title, subtitle.
 *
 * Matches the static report's `.hero` section:
 *   OPERATIONAL STATUS REPORT
 *   Illegal Dumping Monitoring at <tenant>
 *   A 7-day view of monitoring activity ...
 *   Reporting window: ...
 *
 * The reporting window sits directly below the blurb so the reader
 * sees the period covered before any KPI numbers, mirroring the
 * static report's information hierarchy.
 */
export function WasteSenseHero({ tenantName, reportingWindow }: WasteSenseHeroProps) {
  return (
    <View gap="md" alignItems="flex-start">
      <Card bg="muted" px="md" py="xs" rounded={4} borderWidth={0}>
        <Text textStyle="xs/semibold" color="textMuted" letterSpacing={1} textTransform="uppercase">
          Operational status report
        </Text>
      </Card>
      <Text textStyle="h3" color="text">
        Illegal Dumping Monitoring at {tenantName}
      </Text>
      <Text textStyle="sm/regular" color="textMuted">
        A 7-day view of monitoring activity across {tenantName} sites, including incidents identified and alerts
        filtered by AI.
      </Text>
      <Text textStyle="sm/regular" color="text">
        Reporting window: {reportingWindow}
      </Text>
    </View>
  );
}
